window.theme.calcHeight = ($target) => {
  let elements = document.querySelectorAll($target);
  let cacheHeight = 0;
  elements.forEach(ele => {
    (ele.clientHeight > cacheHeight) ? cacheHeight = ele.clientHeight : cacheHeight = cacheHeight;
  });
  elements.forEach(ele => ele.style.height = `${cacheHeight}px`)
}
window.addEventListener('DOMContentLoaded', () => {
  window.theme.calcHeight('.featured-products .product-url'); 
})